"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLoadingFallback = DefaultLoadingFallback;
const react_1 = __importDefault(require("react"));
/**
 *
 * @returns Activity indicator that takes the whole parent size and
 * shows a circular progress icon in the center.
 */
function DefaultLoadingFallback() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", null, `
      @keyframes identity-dash {
        0% {
          stroke-dashoffset: 140;
        }
        50% {
          stroke-dashoffset: 30;
          transform: rotate(135deg);
        }
        100% {
          stroke-dashoffset: 140;
          transform: rotate(450deg);
        }
      }
      
      @keyframes identity-rotator {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(270deg);
        }
      }
      `),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            } },
            react_1.default.createElement("svg", { style: {
                    animation: 'identity-rotator 1.4s linear infinite',
                }, width: "40px", height: "40px", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", role: "progressbar", "aria-label": "loading" },
                react_1.default.createElement("circle", { style: {
                        strokeDasharray: '140',
                        strokeDashoffset: '0',
                        transformOrigin: 'center',
                        stroke: '#1860CF',
                        animation: 'identity-dash 1.4s ease-in-out infinite',
                        WebkitAnimation: 'identity-dash 1.4s ease-in-out infinite',
                    }, fill: "none", strokeWidth: "3", cx: "20", cy: "20", r: "18" })))));
}
